import { memo } from 'react';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CallDuration({
  callInProgress,
  duration
}) {
  let messageKey = `conversations-calling-message.timeline-call-metadata.call-duration.value`;
  let minutes;
  let seconds;
  if (typeof duration === 'number') {
    const momentDuration = I18n.moment.duration(duration, 'milliseconds');
    minutes = momentDuration.get('minutes');
    seconds = momentDuration.get('seconds');
    if (minutes && !seconds) {
      messageKey = `conversations-calling-message.timeline-call-metadata.call-duration.minutes`;
    } else if (!minutes && seconds) {
      messageKey = `conversations-calling-message.timeline-call-metadata.call-duration.seconds`;
    }
  }
  return /*#__PURE__*/_jsx(FormControl, {
    "data-test-id": "call-duration",
    label: /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      typography: "detail-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-calling-message.timeline-call-metadata.call-duration.label"
      })
    }),
    marginBlockStart: "0",
    paddingBlockStart: "100",
    paddingBlockEnd: "400",
    children: callInProgress ? /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-calling-message.timeline-call-metadata.call-duration.processing"
      }), /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.timeline-call-metadata.call-duration.processing-tooltip"
        }),
        marginInlineStart: "100"
      })]
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: messageKey,
      options: {
        minutes,
        seconds
      }
    })
  });
}
export default /*#__PURE__*/memo(CallDuration);